export const initTextFunctions = () => {
    //Loading text clamp utility fuction
    clampTitles();
}


// create funciton to flexibly clamp card title and cardInfos to three lines
    const clampTitles = () => {
        const cardContainers = document.querySelectorAll('.card-container');
        if (cardContainers.length === 0) return;
        cardContainers.forEach(container => {
            const cardContainerWidth = container.offsetWidth;
            const cards = container.querySelectorAll('.card'); // Selecting cards inside container
            let currentRowWidth = 0;
            let rows = [[]];
            
            cards.forEach(card => {
                const cardWidth = card.offsetWidth;
                currentRowWidth += cardWidth;
                
                if (currentRowWidth > cardContainerWidth) {
                    rows.push([]);
                    currentRowWidth = cardWidth;
                }
                
                rows[rows.length - 1].push(card);
            });

            rows.forEach(row => {
                let largestTitleHeight = 0;
                let largestCardInfoHeight = 0;

                row.forEach(card => {
                    const title = card.querySelector('.card-title'); 
                    const cardInfo = card.querySelector('.card-info'); 

                    if (title) {
                        const titleHeight = title.offsetHeight;
                        largestTitleHeight = Math.max(largestTitleHeight, titleHeight);
                    }

                    if (cardInfo) {
                        const cardInfoHeight = cardInfo.offsetHeight;
                        largestCardInfoHeight = Math.max(largestCardInfoHeight, cardInfoHeight);
                    }
                });
                
                // const titles = [];
                // const cardInfos = [];

                row.forEach(card => {
                    const title = card.querySelector('.card-title');
                    const cardInfo = card.querySelector('.card-info');

                    title.style.height = `${largestTitleHeight}px`;
                    cardInfo.style.height = `${largestCardInfoHeight}px`;
                });

            });
        });
    };